import script from "./ScorePlay.vue?vue&type=script&setup=true&lang=js"
export * from "./ScorePlay.vue?vue&type=script&setup=true&lang=js"

import "./ScorePlay.vue?vue&type=style&index=0&id=ccfd8592&lang=less&scoped=true"
import "./ScorePlay.vue?vue&type=style&index=1&id=ccfd8592&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccfd8592"]])

export default __exports__